import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { CKEditorModule } from '@ckeditor/ckeditor5-angular'
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha'

import { BreadcrumbsComponent } from '../../shared/partials/breadcrumbs/breadcrumbs.component'
import { CheckBoxInputComponent } from '../../shared/partials/check-box-input/check-box-input.component'
import { ListFilterComponent } from '../../shared/partials/list-filter/list-filter.component'
import { MultiTagsInputComponent } from '../../shared/partials/multi-tags-input/multi-tags-input.component'
import { PaginationComponent } from '../../shared/partials/pagination/pagination.component'
import { SearchInputComponent } from '../../shared/partials/search-input/search-input.component'
import { SelectAutocompleteInputComponent } from '../../shared/partials/select-autocomplete-input/select-autocomplete-input.component'
import { SocialShareComponent } from '../../shared/partials/social-share/social-share.component'
import { StripHtmlPipe } from '../../shared/pipes/strip-html.pipe'
import { TruncatePipe } from '../../shared/pipes/truncate.pipe'
import { DocumentListComponent } from '../../shared/resources/document/document-list/document-list.component'
import { PostCardComponent } from '../../shared/resources/post/post-card/post-card.component'
import { ToolsCatalogueLoaderComponent } from './base-components/tools-catalogue-loader.component'
import { ThankYouComponent } from './pages/thank-you/thank-you.component'
import { ToolsCatalogueContributeComponent } from './pages/tools-catalogue-contribute/tools-catalogue-contribute.component'
import { ToolsCatalogueFaqComponent } from './pages/tools-catalogue-faq/tools-catalogue-faq.component'
import { ToolsCatalogueOverviewComponent } from './pages/tools-catalogue-overview/tools-catalogue-overview.component'
import { FlagModalComponent } from './partials/flag-modal/flag-modal.component'
import { ImageGalleryModalComponent } from './partials/image-gallery-modal/image-gallery-modal.component'
import { ImageInputComponent } from './partials/image-input/image-input.component'
import { RichTextInputComponent } from './partials/rich-text-input/rich-text-input.component'
import { ToolsCatalogueDisclaimerComponent } from './partials/tools-catalogue-disclaimer/tools-catalogue-disclaimer.component'
import { ToolsCatalogueMenuComponent } from './partials/tools-catalogue-menu/tools-catalogue-menu.component'
import { ToolsCatalogueSubmenuComponent } from './partials/tools-catalogue-submenu/tools-catalogue-submenu.component'
import { MetricUseCaseCardComponent } from './resources/metric-use-case/metric-use-case-card/metric-use-case-card.component'
import { MetricUseCaseCreateComponent } from './resources/metric-use-case/metric-use-case-create/metric-use-case-create.component'
import { MetricUseCaseDetailComponent } from './resources/metric-use-case/metric-use-case-detail/metric-use-case-detail.component'
import { MetricUseCaseListComponent } from './resources/metric-use-case/metric-use-case-list/metric-use-case-list.component'
import { MetricCardComponent } from './resources/metric/metric-card/metric-card.component'
import { MetricCreateComponent } from './resources/metric/metric-create/metric-create.component'
import { MetricDetailComponent } from './resources/metric/metric-detail/metric-detail.component'
import { MetricListComponent } from './resources/metric/metric-list/metric-list.component'
import { ToolUseCaseCardComponent } from './resources/tool-use-case/tool-use-case-card/tool-use-case-card.component'
import { ToolUseCaseCreateComponent } from './resources/tool-use-case/tool-use-case-create/tool-use-case-create.component'
import { ToolUseCaseDetailComponent } from './resources/tool-use-case/tool-use-case-detail/tool-use-case-detail.component'
import { ToolUseCaseListComponent } from './resources/tool-use-case/tool-use-case-list/tool-use-case-list.component'
import { ToolCardComponent } from './resources/tool/tool-card/tool-card.component'
import { ToolCreateComponent } from './resources/tool/tool-create/tool-create.component'
import { ToolDetailComponent } from './resources/tool/tool-detail/tool-detail.component'
import { ToolListComponent } from './resources/tool/tool-list/tool-list.component'
import { ToolsCatalogueRoutingModule } from './tools-catalogue.routes'

@NgModule({
  declarations: [
    ToolsCatalogueMenuComponent,
    ToolsCatalogueOverviewComponent,
    ToolCardComponent,
    ToolCreateComponent,
    ToolListComponent,
    ToolDetailComponent,
    ToolUseCaseDetailComponent,
    ToolUseCaseListComponent,
    ToolUseCaseCreateComponent,
    ToolUseCaseCardComponent,
    FlagModalComponent,
    ImageGalleryModalComponent,
    MetricListComponent,
    MetricCreateComponent,
    ThankYouComponent,
    ToolsCatalogueMenuComponent,
    ToolsCatalogueFaqComponent,
    MetricCardComponent,
    MetricDetailComponent,
    MetricUseCaseCreateComponent,
    MetricUseCaseCardComponent,
    MetricUseCaseListComponent,
    MetricUseCaseDetailComponent,
    ToolsCatalogueLoaderComponent,
    ToolsCatalogueSubmenuComponent,
    ToolsCatalogueContributeComponent,
    FlagModalComponent,
    RichTextInputComponent,
    ImageInputComponent
  ],
  imports: [
    CommonModule,
    ToolsCatalogueRoutingModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    ReactiveFormsModule,
    CKEditorModule,

    // Standalone.
    PaginationComponent,
    DocumentListComponent,
    PostCardComponent,
    SocialShareComponent,
    StripHtmlPipe,
    TruncatePipe,
    SearchInputComponent,
    BreadcrumbsComponent,
    ToolsCatalogueDisclaimerComponent,
    ListFilterComponent,
    MultiTagsInputComponent,
    SelectAutocompleteInputComponent,
    CheckBoxInputComponent
  ]
})
export class ToolsCatalogueModule {}
